import React from 'react';
import { type RelayEnvironment } from 'utils/relayEnvironment';

export type RelayEnvironmentType = RelayEnvironment;
export type RelayEnvironmentContextType = {
  relayEnvironment: RelayEnvironment,
};

export default React.createContext(() => {});
